import type { SxProps, Theme } from '@mui/material/styles';
import { fieldSx } from './utils/styles.ts';

export const selectSx: SxProps<Theme> = {
  ...fieldSx,
  flexShrink: 0,
  minWidth: 110,
  borderRadius: '2px',
  color: 'text.secondary',
  '& .MuiSelect-select': { py: 0, pl: '11px', pr: '34px !important', lineHeight: '34px', minHeight: 0 },
  '& .MuiSelect-icon': { right: 6, top: 'calc(50% - 11px)', fontSize: 22, color: 'text.secondary' },
};
